export class VivitekProjector7000 {
    constructor(socket, log) {
        this.socket = socket;
        this.displayBlank = false;
        this.displayFreeze = false;
        this.input = '6'; // hdmi 1
        this.power = false;
        this.firmwareVersion = 'MP15-SD09-Fxxx-LD08-?-RP03-3092';
        this.serialNumber = '907MXEZPR188';
        this.temperature = 25; // degrees C in decimal
        this.laserHours = 0;
        this.speakerVolume = 5;
        this.volumeMute = false;
        // Support inputs for all models.
        this.validVideoInputs = ['0', '1', '2', '3', '4', '5', '6', '7', '9', '15'];
        this.asyncHandlers = [
            {
                name: 'displayBlank',
                regExp: /op\s+blank\s+\?|op\s+blank\s+=\s+(\d)/i,
                callback: (match) => {
                    if (this.power) {
                        if (match[1])
                            this.displayBlank = match[1] === '1';
                        this.socket.send(`OP BLANK = ${this.displayBlank ? '1' : '0'}`);
                    }
                },
            },
            {
                name: 'displayFreeze',
                regExp: /op\s+freeze\s+\?|op\s+freeze\s+=\s+(\d)/i,
                callback: (match) => {
                    if (this.power) {
                        if (match[1])
                            this.displayFreeze = match[1] === '1';
                        this.socket.send(`OP FREEZE = ${this.displayFreeze ? '1' : '0'}`);
                    }
                },
            },
            {
                name: 'firmwareVersionGet',
                regExp: /op\s+sw\.ver\s+\?/i,
                callback: (match) => {
                    if (this.power) {
                        this.socket.send(`OP SW.VER = ${this.firmwareVersion}`);
                    }
                },
            },
            {
                name: 'input',
                regExp: /op\s+input\.sel\s+\?|op\s+input\.sel\s+=\s+(\d+)/i,
                callback: (match) => {
                    if (this.power) {
                        if (match[1])
                            this.input = match[1];
                        const result = this.validVideoInputs.includes(this.input) ? this.input : 'NA';
                        this.socket.send(`OP INPUT.SEL = ${result}`);
                    }
                },
            },
            {
                name: 'status',
                regExp: /op\s+status\s+\?/i,
                callback: (match) => {
                    this.socket.send(`OP STATUS = ${this.power ? '2' : '0'}`);
                },
            },
            {
                name: 'power',
                regExp: /op\s+power\.(on|off)/i,
                callback: (match) => {
                    this.power = match[1].toUpperCase() === 'ON' ? true : false;
                    this.socket.send(`OP POWER.${this.power ? 'ON' : 'OFF'}`);
                },
            },
            {
                name: 'serialNumberGet',
                regExp: /op\s+ser\.no\s+\?/i,
                callback: (match) => {
                    if (this.power) {
                        this.socket.send(`OP SER.NO = ${this.serialNumber}`);
                    }
                },
            },
            {
                name: 'temperatureGet',
                regExp: /op\s+(t[icb]\d*)\s+\?/i,
                callback: (match) => {
                    if (this.power) {
                        this.socket.send(`op ${match[1]} = ${this.temperature.toString(10)}`);
                    }
                },
            },
            {
                name: 'laserHoursGet',
                regExp: /op\s+laser\.hours\s+\?/i,
                callback: (match) => {
                    if (this.power) {
                        this.socket.send(`OP LASER.HOURS = ${this.laserHours.toString(10)}`);
                        this.laserHours++;
                    }
                },
            },
            {
                name: 'volume',
                regExp: /op\s+volume\s+\?|op\s+volume\s+=\s+(\d+)/i,
                callback: (match) => {
                    if (this.power) {
                        if (match[1] !== undefined) {
                            const speakerVolume = parseInt(match[1], 10);
                            if (speakerVolume >= 0 && speakerVolume <= 10) {
                                this.speakerVolume = speakerVolume;
                            }
                        }
                        this.socket.send(`OP VOLUME = ${this.speakerVolume.toString(10)}`);
                    }
                },
            },
            {
                name: 'volumeMute',
                regExp: /op\s+mute\s+\?|op\s+mute\s+=\s+(\d)/i,
                callback: (match) => {
                    if (this.power) {
                        if (match[1])
                            this.volumeMute = match[1] === '1';
                        this.socket.send(`OP MUTE = ${this.volumeMute ? '1' : '0'}`);
                    }
                    // no response if powered off
                },
            },
        ];
    }
    onConfigure(config) {
        var _a;
        let lowestCode;
        for (const videoInput of Object.values((_a = config.videoInputs) !== null && _a !== void 0 ? _a : {})) {
            const code = videoInput.code;
            if (this.input === code)
                return;
            if (lowestCode === undefined || parseInt(code, 10) < parseInt(lowestCode, 10)) {
                lowestCode = code;
            }
        }
        this.input = lowestCode !== null && lowestCode !== void 0 ? lowestCode : '6';
    }
}
VivitekProjector7000.emulatorType = 'socketEmulator';
VivitekProjector7000.key = '-MCChooqa81xM8o0Nxsg';
